import { GenericDatabase } from './GenericDatabase'

const DB_NAME = '3Ds'
const DB_VERSION = 1
const STORE_NAME = '3dFilesList'

const dbInstance = new GenericDatabase(DB_NAME, DB_VERSION, [
    {
        name: STORE_NAME,
        keyPath: 'id',
        indices: [
            { name: 'model', keyPath: 'model', options: { unique: false } },
            { name: 'name', keyPath: 'name', options: { unique: false } },
            { name: 'type', keyPath: 'type', options: { unique: false } },
            { name: 'brand', keyPath: 'brand', options: { unique: false } },
            { name: 'nameModel', keyPath: 'nameModel', options: { unique: false } }
        ]
    }
])

const initDb3DFiles = () => {
    return dbInstance.init()
}

const agregar = (data, database) => {
    // Original: returned a Promise, resolved true if success (and called consultar internally), false if error.
    // We will chain the add.
    return dbInstance.add(STORE_NAME, data, database)
}

const obtener = (clave, database) => {
    return dbInstance.get(STORE_NAME, Number(clave), database)
}

const buscarPorNombreModelo = (value, database) => {
    // Original: returned a Promise, resolved with result of index 'nameModel'.
    return dbInstance.getByIndex(STORE_NAME, 'nameModel', value, database)
}

const actualizar = (data, database) => {
    return dbInstance.put(STORE_NAME, data, database)
}

const eliminar = (clave, database) => {
    return dbInstance.delete(STORE_NAME, clave, database)
}

const consultar = (database) => {
    return dbInstance.getAll(STORE_NAME, database)
}

export default {
    initDb3DFiles,
    agregar,
    obtener,
    actualizar,
    eliminar,
    consultar,
    buscarPorNombreModelo
}
